import React, { useState } from "react";
import "../index.css";

const INK = "#1A1A1A";
const INK_MID = "#444";
const FONT_DISPLAY = "'Fredoka', sans-serif";
const FONT_BODY = "'Nunito', sans-serif";

const cardStyle: React.CSSProperties = {
  background: "#FFFFFF",
  border: `2.5px solid ${INK}`,
  borderRadius: 16,
  boxShadow: `4px 4px 0px ${INK}`,
  padding: 16,
  marginBottom: 12,
  display: "flex",
  alignItems: "center",
  gap: 12,
  cursor: "pointer",
  boxSizing: "border-box",
  width: "100%",
};

const cardTitleStyle: React.CSSProperties = {
  fontFamily: FONT_DISPLAY,
  fontSize: 17,
  fontWeight: 700,
  color: INK,
  margin: 0,
  lineHeight: 1.2,
};

const cardBodyStyle: React.CSSProperties = {
  fontFamily: FONT_BODY,
  fontSize: 14,
  color: INK_MID,
  lineHeight: 1.45,
  marginTop: 6,
  marginBottom: 0,
};

const cardHintStyle: React.CSSProperties = {
  fontFamily: FONT_BODY,
  fontSize: 13,
  color: INK_MID,
  fontStyle: "italic",
  opacity: 0.85,
  marginTop: 4,
  marginBottom: 0,
};

// ZodiYak images
const marketingImages = [
  "/SVG/zodiyak-aquarius.svg",
  "/SVG/zodiyak-aries.svg",
  "/SVG/zodiyak-gemini.svg",
  "/SVG/zodiyak-pisces.svg",
  "/SVG/zodiyak-sagittarius.svg",
  "/SVG/zodiyak-virgo.svg",
  "/SVG/zodiyak-taurus.svg",
  "/SVG/zodiyak-leo.svg",
  "/SVG/zodiyak-capricorn.svg",
  "/SVG/zodiyak-scorpio.svg",
];

const marketingMessages = [
  "No Risk By Design",
  "Match With Who You Know",
  "Start on the Same Page",
  "Post It, Let em Cook",
  "It Takes Two",
  "Are They Already Waiting",
  "Pay Once, Never Again",

];

const marketingDescriptions = [
  "When you match, only you and your Crush will know. If it isn’t mutual, nobody ever finds out.",
  "No profiles. No swiping. Add your Crush's social handles, phone number, or email to your list.",
  "Curious, Like Like, Down Bad — pick your vibe when you add your Crush. We only reveal the highest shared vibe, so you never look more into it than they do.",
  "Maybe your Crush sees it, or maybe they get pulled in when your circle does. Either way, your odds just went up.",
  "To match, your Crush needs to be able to add you too. That’s why you verify your phone number, email, and social handles.",
  "The second someone adds you as their secret crush, we tell you — free. You'll even see how many. We just don't say who, unless you match.",
  "Matching unlocks and stays unlocked. Your list can change, your feelings can change — you'll never pay again.",

];

const MarketingCards: React.FC = () => {
  const [revealed, setRevealed] = useState<boolean[]>(
    Array(marketingMessages.length).fill(false)
  );

  const toggleCard = (index: number) => {
    setRevealed(prev => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  };

  const onKey = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleCard(index);
    }
  };

  return (
    <section className="cards-section">
      <div className="cards-grid">
        <div>
          <h2
            style={{
              background: "#e54c4c",
              border: "3px solid #1A1A1A",
              borderRadius: 20,
              boxShadow: "6px 6px 0px #1A1A1A",
              padding: "20px 24px",
              fontFamily: "'Fredoka', sans-serif",
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: 600,
              color: "#FFFFFF",
              textAlign: "center",
              marginBottom: 16,
            }}
          >
            Okay But How Does It Work
          </h2>
        </div>

        {marketingMessages.map((title, index) => {
          const isOpen = revealed[index];
          return (
            <div
              key={index}
              role="button"
              tabIndex={0}
              aria-expanded={isOpen}
              onClick={() => toggleCard(index)}
              onKeyDown={(e) => onKey(e, index)}
              style={cardStyle}
            >
              <img
                src={marketingImages[index % marketingImages.length]}
                alt={`ZodiYak character for ${title}`}
                className="card__img"
                draggable={false}
              />

              <div className="card__text">
                <h3 style={cardTitleStyle}>{title}</h3>

                {isOpen ? (
                  <p style={cardBodyStyle}>
                    {marketingDescriptions[index % marketingDescriptions.length]}
                  </p>
                ) : (
                  <p style={cardHintStyle}>Click to Reveal</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default MarketingCards;
